<!-- Hero Start -->
<div class="container-fluid bg-primary p-5 bg-hero mb-5">
    <div class="row py-5">
        <div class="col-12 text-center">
            <h1 class="display-2 text-white mb-md-4">Protege a tu Familia</h1>
            <a href="https://play.google.com/store/apps/details?id=com.wescotcorp.sospect"
                class="btn btn-dark py-md-3 px-md-5 me-3">Descargar</a>
            <a href="javascript:void(0)" class="btn btn-outline-light py-md-3 px-md-5">App Store (Próximamente)</a>
        </div>
    </div>
</div>
<!-- Hero End -->

<!-- About Section -->
<div class="container py-5">
    <div class="row g-5">
        <div class="col-lg-5">
            <img class="img-fluid rounded" src="images/SospectShooter1.JPG" alt="Promocional SOSpect">
        </div>
        <div class="col-lg-7">
            <h2>¿Qué es SOSpect?</h2>
            <p>En ocasiones sabes cuando algo o alguien es un riesgo para ti o para los tuyos… la vida está en juego.
                Muchas veces no tienes como pedir ayuda o ayudar a quienes te importan. Con SOSpect podrás enviar una
                alarma a tu comunidad para evitarles estar en riesgo o para que te ayuden a ti si lo necesitas.</p>
            <p>Con SOSpect podrás proteger a tu familia y estar pendiente de las alertas que se produzcan en los sitios
                que te importan, por ejemplo, el colegio de tus hijos. Quienes reciban tu alarma podrán tomar acción
                preventiva si lo requieren. SOSpect es la herramienta gratuita ideal para potenciar la unión de la
                comunidad para evitar peligros o enfrentarlos. SOSpect: los criminales pierden, tú ganas.</p>
        </div>
    </div>
</div>
<!-- About End -->